import "./style.scss";

import Management from "assets/img/svg/navbar/management";
import classNames from "classnames";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type NavigationPreviewTarget = "management";

const NAVIGATION_PREVIEW_CONFIG: Record<NavigationPreviewTarget, { icon: ReactNode; labelKey: string }> = {
    management: {
        icon: <Management />,
        labelKey: "NavigationBar.Management",
    },
};

interface INavigationPreview {
    target?: NavigationPreviewTarget;
    className?: string;
}

/**
 * Inline chip mimicking a sidebar navigation item (icon + label).
 */
const NavigationPreview = ({ target = "management", className }: INavigationPreview) => {
    const [t] = useTranslation();
    const { icon, labelKey } = NAVIGATION_PREVIEW_CONFIG[target];

    return (
        <span className={classNames("navigation-preview", className)} title={t(labelKey)}>
            <span className="navigation-preview__icon" aria-hidden>
                {icon}
            </span>
            <span className="navigation-preview__label">{t(labelKey)}</span>
        </span>
    );
};

export default NavigationPreview;
